import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isNil, propEq, find, pathOr } from 'ramda';

import useBidRequests from 'reducers/hooks/useBidRequests';
import FirebaseChatPresenter from 'presenters/FirebaseChatPresenter';
import ChatPresenter from 'presenters/ChatPresenter';

import useFirebaseChat from 'reducers/hooks/firebase/useChat';

import { Box } from '@material-ui/core';
import UserPresenter from 'presenters/UserPresenter';
import BuyersChatList from 'sharedComponents/BuyersChatList';
import ChatPage from './components/ChatPage';
import ActionPage from './components/ActionPage';

import useStyles from './useStyles';

const MobileMessages = props => {
  const classes = useStyles();
  const {
    isOnline,
    currentUser,
    onChatSelect,
    onMessageSend,
    onMessagesRead,
    selectedChatUid,
    chats,
    chatsInfo,
    onUnselectChat,
    ...rest
  } = props;

  const [showActionPagePage, setShowActionPagePage] = useState(false);
  const isChatSelected = !isNil(selectedChatUid);
  const { bidRequests } = useBidRequests();
  const { usersOnlineStatusList } = useFirebaseChat();

  const handleOpenActionPagePage = () => setShowActionPagePage(true);
  const handleCloseActionPage = () => setShowActionPagePage(false);

  if (!isChatSelected) {
    return (
      <Box className={classes.paper}>
        <BuyersChatList
          chatsInfo={chatsInfo}
          chats={chats}
          bidRequests={bidRequests}
          onChatSelect={onChatSelect}
          {...rest}
        />
      </Box>
    );
  }

  const selectedChatInfo = chatsInfo[selectedChatUid];
  const selectedChat = find(propEq('uid', selectedChatUid), chats);
  const selectedChatBuyerId = FirebaseChatPresenter.buyerId(selectedChat);
  const bidRequest = bidRequests.find(({ buyerId }) => buyerId === selectedChatBuyerId);
  const isOnlineSelectedChatLoanOfficer = pathOr(false, [selectedChatBuyerId, 'isOnline'], usersOnlineStatusList);
  const chatParticipant = ChatPresenter.buildChatParticipantFromBuyer(
    selectedChatBuyerId,
    selectedChatInfo,
    isOnlineSelectedChatLoanOfficer,
  );

  if (showActionPagePage) {
    return (
      <ActionPage
        bidRequest={bidRequest}
        onBack={handleCloseActionPage}
        chatUid={selectedChatUid}
        chatParticipant={chatParticipant}
      />
    );
  }

  return (
    <Box className={classes.root}>
      <ChatPage
        chat={selectedChat}
        isOnline={isOnline}
        currentUser={currentUser}
        onMessageSend={onMessageSend}
        onMessagesRead={onMessagesRead}
        onBack={onUnselectChat}
        chatInfo={selectedChatInfo}
        bidRequest={bidRequest}
        selectedChatUid={selectedChatUid}
        onOpenLoanOfficerPage={handleOpenActionPagePage}
        chatParticipant={chatParticipant}
      />
    </Box>
  );
};

MobileMessages.propTypes = {
  isOnline: PropTypes.bool.isRequired,
  currentUser: UserPresenter.shape().isRequired,
  onChatSelect: PropTypes.func.isRequired,
  onMessageSend: PropTypes.func.isRequired,
  onMessagesRead: PropTypes.func.isRequired,
  selectedChatUid: PropTypes.string,
  chats: PropTypes.arrayOf(FirebaseChatPresenter.shape()).isRequired,
  chatsInfo: PropTypes.shape().isRequired,
  onUnselectChat: PropTypes.func.isRequired,
};

MobileMessages.defaultProps = {
  selectedChatUid: '',
};

export default MobileMessages;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerMessages/components/MobileMessages/MobileMessages.js